require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-chandler-highway-upgrade-complete.json") })
        }
      }, "path---news-chandler-highway-upgrade-complete");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-chandler-highway-upgrade-complete!./.cache/json/news-chandler-highway-upgrade-complete.json
// module id = 801
// module chunks = 231608221292675